import { TOGGLE_MODIFICATION_CONTAINER } from "./displayModificationContainerReducer"

export const toggleModificationContainer = (obj) => ({
    type: TOGGLE_MODIFICATION_CONTAINER,
    payload: obj
})